import {Pagination} from './Pagination';
import {SortDirection} from './SortDirection';
import {UserLayoutType} from './UserLayoutType';

/**
 * @export
 * @type UserLayoutRequest
 */
export type UserLayoutRequest = {
    page: Pagination;
    sortDirection: SortDirection;
    sortBy: UserLayoutRequestSortBy;
    layoutType?: UserLayoutType;
    entityTypes?: Array<string>;
    searchByName?: string;
}

export enum UserLayoutRequestSortBy {
    NAME = 'NAME',
    ENTITY_TYPE = 'ENTITY_TYPE'
}